
<div style="position: relative"> 
    <!-- It is really important to set loaderId for non-master loader -->
    <ngx-ui-loader [bgsType]="'three-strings'" [fgsType]="'cube-grid'" ></ngx-ui-loader>
  </div>


  <dx-toast
  *ngIf="toastData"
  [message]="toastData?.title"
  [type]="'info'"
  [displayTime]="toastData?.timeout || 3000"
  [visible]="true"
  (onHiding)="toastData = null"
  [position]="{ my: { x: 'right', y: 'top' }, at: { x: 'right', y: 'top' }, offset: { x: 0, y: 20 } }"
  [height]="'auto'">
  <div *dxTemplate="let data of 'content'" [ngStyle]="{ backgroundColor: toastData?.color || '#fff' }">
    <div class="toast-content">
      <div class="toast-icon">
        <i [class]="toastData?.icon"></i>
      </div>
      <div>
        <p [innerHTML]="toastData?.title"></p>
        <small [innerHTML]="toastData?.content"></small>
      </div>
    </div>
  </div>
</dx-toast>

  <app-confirm-dialog
  *ngIf="confirmDialogData"
  [visible]="true"
  [title]="confirmDialogData.title"
  [content]="confirmDialogData.content"
  (closed)="onDialogClosed($event)">
</app-confirm-dialog>
<router-outlet (activate)="onActivate($event)"></router-outlet>